import PropTypes from 'prop-types';
import React, {useEffect, useState} from 'react';

import {getAllBanks} from '../../../services/Api';
import {ErrorWarning} from '../../../shared/components/ErrorWarning';
import {useChatStore} from '../../../store/slices/chatStore';
import {useInteractionStore} from '../../../store/slices/interactionStore';
import BankNameInput from '../BankNameInput';
import BanksListNames from '../BanksListNames';
import './BankSelector.style.scss';

const BankSelector = (props) => {
  const bankObject = useChatStore((state) => state.bankObject);
  const setBankObject = useChatStore((state) => state.setBankObject);
  const setBanksListGlobal = useChatStore((state) => state.setBanksListGlobal);
  const disabledButtonSendMessage = useInteractionStore(
    (state) => state.disabledButtonSendMessage
  );
  const setDotTyping = useInteractionStore((state) => state.setDotTyping);
  const haveOnlyPsrMigratedSelected = useInteractionStore(
    (state) => state.haveOnlyPsrMigratedSelected
  );
  // Valor do input de filtragem
  const [bankName, setBankName] = useState('');
  // Lista de banco do GET
  const [banksList, setBanksList] = useState([]);
  // Opções exibidas no front para escolha após filtragem
  const [banksListOptions, setBanksListOptions] = useState([]);
  // Trava ou libera o input usado para enviar banco escolhido
  const [inputUseBar, setInputUseBar] = useState(true);
  // Mensagens informativas sobre a exibição de opções
  const [requestError, setRequestError] = useState(false);

  /**
   * Se clicar no input com opção escolhida limpar
   * escolha para escolher novamente
   * @param {*} e
   */
  const handlerResetBankSelected = (e) => {
    props.onChange({
      ...e,
      target: {
        ...e.target,
        value: ''
      }
    });

    setInputUseBar(false);
    disabledButtonSendMessage('disabled');

    let input = document.getElementById('message');
    if (input) input.focus();
  };

  /**
   * Habilita o input principal para envio com a
   * opção selecionada
   * @param {*} e
   */
  const handlerSelectOption = (e) => {
    // Selecting a bank
    let bankAttr = e.target.dataset.bankOption;
    bankAttr = JSON.parse(bankAttr);
    setBankObject({
      ...bankObject,
      code: bankAttr.code,
      name: bankAttr.name,
      mask: bankAttr.mask
    });
    // Limpa nome de banco digitado no input de busca
    setBankName('');
    // Limpa a lista de bancos para escolha
    setBanksListOptions([]);
    // Mostrar input ligado a useBar com opção escolhida
    setInputUseBar(true);
    // Coloca o bank escolhido no input da useBar
    props.onChange({
      ...e,
      target: {
        ...e.target,
        value: e.target.innerText
      }
    });

    disabledButtonSendMessage('');

    // Foca o input após seleção
    setTimeout(() => {
      let input = document.getElementById('message');
      if (input) input.focus();
    }, 0);
  };

  const getAllBanksGroupSuccess = (response) => {
    if (response.data !== '') {
      setRequestError(false);
      const bankGroup = response.data.list.map((bank) => {
        return {
          code: bank.id.toString(),
          name: bank.name,
          mask: bank.accountMask
        };
      });
      // Criar lista para busca das opções compatíveis
      setBanksList(bankGroup);
      setBanksListGlobal(bankGroup);
      // Se sucesso liberar input select
      setInputUseBar(false);
    }
  };

  const getAllBanksGroupError = () => {
    setRequestError(true);
    setBankName('');
    setInputUseBar(false);
    setBanksListGlobal([]);
  };

  const getAllBanksGroup = () => {
    if (banksList.length > 0) return;
    setDotTyping(true);
    getAllBanks(haveOnlyPsrMigratedSelected)
      .then((response) => {
        setDotTyping(false);
        getAllBanksGroupSuccess(response);
      })
      .catch(() => {
        setDotTyping(false);
        getAllBanksGroupError();
      });
  };

  /**
   * Exibe lista com as opções digitada
   */
  useEffect(() => {
    // Filtrar a lista retornada após 3 letras digitadas
    if (bankName === '' || bankName.length < 1) return;
    let filter = bankName.toUpperCase();
    let newList = banksList.filter(
      (bank) =>
        bank.name.toUpperCase().indexOf(filter) > -1 ||
        bank.code.indexOf(filter) > -1
    );

    // Exibir a lista filtrada para escolha do EC
    setBanksListOptions(newList);
  }, [bankName, banksList]);

  /**
   * Busca a lista de bancos no serviço
   */
  useEffect(() => {
    getAllBanksGroup();
  }, []);

  return (
    <>
      {requestError && (
        <ErrorWarning
          htmlId="repeat-request-banks"
          request={getAllBanksGroup}
        />
      )}

      {!requestError && (
        <div className="user-input-banks" data-testid="box-input-bank-select">
          <BankNameInput
            {...props}
            inputUseBar={inputUseBar}
            onClickResetBankSelected={handlerResetBankSelected}
            banksList={banksList}
            boxInformation="Carregando lista de bancos..."
            bankName={bankName}
            onChangeBankName={setBankName}
          />
          <BanksListNames
            inputUseBar={inputUseBar}
            banksListOptions={banksListOptions}
            handlerSelectOption={handlerSelectOption}
          />
        </div>
      )}
    </>
  );
};

BankSelector.propTypes = {
  onChange: PropTypes.func
};

export default BankSelector;
